import { ROUTES } from "../constants/routes";

export const isPublicTeachingPath = (path: string): boolean => {
  const normalized = path.replace(/\/+$/, "");
  return (
    normalized === ROUTES.micropractices ||
    normalized.startsWith(`${ROUTES.micropractices}/`) ||
    normalized === ROUTES.core_tools_posters ||
    normalized.startsWith(`${ROUTES.core_tools_posters}/`)
  );
};
export const isTeachingAnalyticsPath = (path: string): boolean =>
  isPublicTeachingPath(path) ||
  path === ROUTES.teaching ||
  path.startsWith(`${ROUTES.teaching}/`);
